<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              :title="title"
              titleClass="resBlue darken-1 white--text"
              :showTitleIcon="true"
              :titleIconSize="17"
              iconColor="white"
              :saveButtonText="buttonText"
              :saveDisabled="selectedOptions.length === 0"
              cancelButtonText="CANCEL"
              cancelButtonWidth="80"
              :defaultButtonAction="confirm"
              @save="confirm"
              @cancel="cancel" >
    <v-card-text>
      <span class="font-weight-500">
        {{ message }}
      </span>
      <br/>
      <ul class="mt-2">
        <template v-for="option in options">
          <li :key="option.value">
            <v-checkbox class="mt-0" :label="option.text" :value="option.value" v-model="selectedOptions">
            </v-checkbox>
          </li>
        </template>
      </ul>
    </v-card-text>
    <res-dialog :showDialog="showAllSelectedConfirmation"
                :title="title"
                saveButtonText="Yes"
                cancelButtonText="Cancel"
                @save="finalConfirm"
                @cancel="hideAllSelectedConfirmation">{{allSelectedConfirmationMessage}}</res-dialog>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      title: {
        type: String,
        default: 'Select Options'
      },
      message: {
        type: String,
        default: 'Select Options:'
      },
      allSelectedConfirmationMessage: {
        type: String,
        default: null
      },
      buttonText: {
        type: String,
        default: 'Confirm'
      },
      options: {
        type: Array,
        default: () => []
      },
      maxWidth: null,
      setWidth: null
    },
    data: function () {
      return {
        selectedOptions: [],
        showAllSelectedConfirmation: false
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel', true)
      },
      finalConfirm() {
        this.$emit('confirm', { selectedOptions: this.selectedOptions });
        this.hideAllSelectedConfirmation();
        this.cancel();
      },
      confirm() {
        if (this.allSelected) {
          this.showAllSelectedConfirmation = true;
          return;
        }
        this.finalConfirm();
      },
      hideAllSelectedConfirmation() {
        this.showAllSelectedConfirmation = false;
      }
    },
    computed: {
      allSelected() {
        return this.options.length === this.selectedOptions.length;
      }
    }
  }
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
  }
</style>
